import type {IServiceTarget} from "@mytour/shared";
import {Field2} from "@mytour/ui/form";
import type {UseFormReturn} from "react-hook-form";
import z from "zod";

export const step1Schema = z.object({
  discipline: z.string().optional(),

  objectif: z.string().optional(),
  veterinarian: z.string().optional(),
  previousHoofCare: z.string().optional(),
  etatCorporel: z.number().min(1).max(9).nullable(),
});

export type Step1Form = z.infer<typeof step1Schema>;

type Props = {
  cheval: IServiceTarget;
  hookForm: UseFormReturn<Step1Form>;
  disabled: boolean;
};

export function Step1({cheval, hookForm, disabled}: Props) {
  return (
    <>
      <p style={{marginBottom: "24px"}}>
        <strong>Informations de {cheval.label}</strong>
      </p>
      <Field2 name="discipline" hookForm={hookForm} disabled={disabled} />
      <Field2 name="objectif" hookForm={hookForm} disabled={disabled} />
      <Field2 name="veterinarian" label="Vétérinaire" hookForm={hookForm} disabled={disabled} />
      <Field2
        name="previousHoofCare"
        label="Précédent pro. soins aux sabots"
        hookForm={hookForm}
        disabled={disabled}
      />
      <Field2
        name="etatCorporel"
        label="État corporel /9"
        type="number"
        min={1}
        max={9}
        hookForm={hookForm}
        disabled={disabled}
      />
    </>
  );
}
